import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  IconButton,
  Grid
} from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, EffectCoverflow, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-coverflow';

import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import imgUrl from '../assets/images/imgUrl'; // Make sure this path is correct

// Sample data
const videoGallery = [
  {
    title: 'Dure Brochure',
    date: '22/07/2025',
    image: imgUrl.galleryImg4,
  },
  {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg2,
  },
   {
    title: 'Dure Brochure',
    date: '22/07/2025',
    image: imgUrl.galleryImg3,
  },
  {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.dureBrochureImg1,
  },
   {
    title: 'Dure Brochure',
    date: '22/07/2025',
    image: imgUrl.galleryImg5,
  },
  {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg6,
  },
   {
    title: 'Dure Brochure',
    date: '22/07/2025',
    image: imgUrl.galleryImg7,
  },
  {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg8,
  },
   {
    title: 'Dure Brochure',
    date: '22/07/2025',
    image: imgUrl.galleryImg9,
  },
  {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg10,
  },
    {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg11,
  },
   {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg12,
  },
   {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg13,
  },
   {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg14,
  },
  {
    title: 'UNGA Cloud Infrastructure and Digital Health',
    date: '28/09/2025',
    image: imgUrl.galleryImg15,
  },
  {
    title: 'IDF Roundtable',
    date: '19/09/2025',
    image: imgUrl.galleryImg16,
  },
];

const photoGallery = [
  {
    title: 'Dure Brochure',
    date: '22/07/2025',
    image: imgUrl.galleryImg4,
  },
  {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg2,
  },
   {
    title: 'Dure Brochure',
    date: '22/07/2025',
    image: imgUrl.galleryImg3,
  },
  {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.dureBrochureImg1,
  },
   {
    title: 'Dure Brochure',
    date: '22/07/2025',
    image: imgUrl.galleryImg5,
  },
  {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg6,
  },
   {
    title: 'Dure Brochure',
    date: '22/07/2025',
    image: imgUrl.galleryImg7,
  },
  {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg8,
  },
   {
    title: 'Dure Brochure',
    date: '22/07/2025',
    image: imgUrl.galleryImg9,
  },
  {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg10,
  },
    {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg11,
  },
   {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg12,
  },
   {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg13,
  },
   {
    title: 'Global Health Meet',
    date: '15/06/2025',
    image: imgUrl.galleryImg14,
  },
  {
    title: 'UNGA Cloud Infrastructure and Digital Health',
    date: '28/09/2025',
    image: imgUrl.galleryImg15,
  },
  {
    title: 'IDF Roundtable',
    date: '19/09/2025',
    image: imgUrl.galleryImg16,
  },
];

const Gallery = () => {
  const [tab, setTab] = useState(0);
  const [galleryData, setGalleryData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setGalleryData(tab === 0 ? photoGallery : videoGallery );
    setActiveIndex(0); // Reset to first slide on tab switch
  }, [tab]);


  return (
    <Box sx={{ backgroundColor: '#0A1A45', py: 6, px: { xs: 2, md: 6 } }} className="gallerySection">
    
      <Grid container spacing={0}>
        <Grid size={{xs:12, md:10}} sx={{display:'flex' , justifyContent:'center' , alignItems:'center' , paddingLeft:'13%'}} className="galleryPadding">
              <Typography
        variant="h5"
        sx={{ textAlign: 'center', color: 'white', fontWeight: 'bold', mb: 3 }}
      >
        VIDEO AND PHOTO GALLERY
      </Typography>

     
        </Grid>
        <Grid size={{xs:12 , md:2}}>
           {/* Tab Icons */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }} className="galleryButton">
        <Tabs
          value={tab}
          onChange={(e, val) => setTab(val)}
          TabIndicatorProps={{ style: { display: 'none' } }}
          sx={{
            backgroundColor: '#1C2A5E',
            borderRadius: 2,
            overflow: 'hidden',
            p: '4px',
          }}
        >

         <Tab
            icon={<CameraAltIcon />}
            sx={{
              minWidth: 50,
              color: tab === 0 ? '#fff' : '#999',
              backgroundColor: tab === 0 ? '#A349F6' : 'transparent',
              borderRadius: 2,
              mx: 0.5,
            }}
          />
          <Tab
            icon={<VideoCameraFrontIcon />}
            sx={{
              minWidth: 50,
              color: tab === 1 ? '#fff' : '#999',
              backgroundColor: tab === 1 ? '#A349F6' : 'transparent',
              borderRadius: 2,
              mx: 0.5,
            }}
          />
         
        </Tabs>
      </Box>

        </Grid>
      </Grid>

      {/* Swiper Gallery */}
      <Box sx={{ position: 'relative', width: '100%' }}>
        {tab === 0 && (
          <>
       <Swiper
          modules={[Navigation, EffectCoverflow, Autoplay]}
          effect="coverflow"
          centeredSlides={true}
          slidesPerView={3}
          initialSlide={3}
          spaceBetween={-500}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // When window width is <= 768px (common mobile breakpoint)
            0: {
              slidesPerView: 1, // Show only 1 slide on mobile
              spaceBetween: 10, // Adjust space for mobile
            },
            // When window width is >= 769px, revert to default or other settings
            768: {
              slidesPerView: 3, // For larger screens
              spaceBetween: -500,
            },
          }}
          coverflowEffect={{
            rotate: 0,

            stretch: 0,
            depth: 100,
            modifier: 2.5,
            slideShadows: false,
          }}
          navigation={{
            nextEl: '.next-btn',
            prevEl: '.prev-btn',
          }}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        >

          {galleryData.map((item, index) => (
            <SwiperSlide key={index} style={{ width: 250 }}>
              <Box>
                <Box
                  component="img"
                  src={item.image}
                  alt={item.title}
                  className="gallerySwiperImg"
                 
                />
                {/* {index === activeIndex && (
                  <Box sx={{ textAlign: 'center', mt: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: '#fff', fontWeight: 600 }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: '#ccc' }}
                    >
                      {item.date}
                    </Typography>
                  </Box>
                )} */}
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation Arrows */}
        <IconButton
          className="prev-btn"
          sx={{
            position: 'absolute',
            top: '50%',
            left: -20,
            transform: 'translateY(-50%)',
            backgroundColor: '#A349F6',
            color: '#fff',
            zIndex: 2,
            '&:hover': { backgroundColor: '#922de1' },
          }}
        >
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>

        <IconButton
          className="next-btn"
          sx={{
            position: 'absolute',
            top: '50%',
            right: -20,
            transform: 'translateY(-50%)',
            backgroundColor: '#A349F6',
            color: '#fff',
            zIndex: 2,
            '&:hover': { backgroundColor: '#922de1' },
          }}
        >
          <ArrowForwardIosIcon fontSize="small" />
        </IconButton>

        </>
        )}

        {tab === 1 && (
          <Box sx={{ textAlign: 'center', color: 'white', py: 10 }}>
            <Typography variant="h6">
              Video gallery coming soon 🎥
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Gallery;
